import { render, staticRenderFns } from "./DashboardTotalJobs.vue?vue&type=template&id=0f6d399b&scoped=true"
import script from "./DashboardTotalJobs.vue?vue&type=script&lang=js"
export * from "./DashboardTotalJobs.vue?vue&type=script&lang=js"
import style0 from "./DashboardTotalJobs.vue?vue&type=style&index=0&id=0f6d399b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d399b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6d399b')) {
      api.createRecord('0f6d399b', component.options)
    } else {
      api.reload('0f6d399b', component.options)
    }
    module.hot.accept("./DashboardTotalJobs.vue?vue&type=template&id=0f6d399b&scoped=true", function () {
      api.rerender('0f6d399b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardTotalJobs.vue"
export default component.exports